import { ReactElement, SyntheticEvent, useEffect } from 'react';
import { Box, Button, Divider, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { EEventCreateSteps } from '../../types/@event';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { eventActions } from '../../redux/slices/event.slice';

import { styles } from './event-create-team.styles';
import { ITeam } from '../../types/@team';
import { teamActions } from '../../redux/slices/team.slice';

interface IProps {
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

const EventCreateTeam = ({ setStep }: IProps): ReactElement => {
  const dispatch = useDispatch();
  const teamList: ITeam[] = useSelector((state: RootState) => state.teams.all);
  const eventTeam = useSelector((state: RootState) => state.events.eventCreate.team);

  const handleNext = (): void => {
    setStep(() => {
      return EEventCreateSteps.event;
    });
  };
  const handleBack = (): void => {
    setStep(() => {
      return EEventCreateSteps.organisation;
    });
  };

  const handleClick = (ev: SyntheticEvent<HTMLElement>) => {
    const {
      dataset: { idx },
    } = ev.currentTarget as typeof ev.currentTarget & {
      dataset: { idx: string };
    };
    dispatch(eventActions.selectedTeam(teamList[+idx]));
  };

  useEffect(() => {
    dispatch(teamActions.getTeams());
  }, [dispatch]);

  return (
    <Box sx={styles.mainBox}>
      <Box sx={styles.titleBox}>Select Team</Box>
      <Box sx={styles.contentBox}>
        <List sx={styles.listBox}>
          {teamList.map((el, idx) => {
            return (
              <ListItem disablePadding key={el._id}>
                <ListItemButton onClick={handleClick} data-idx={idx}>
                  <ListItemText>{el.name}</ListItemText>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
        <Divider orientation="vertical" sx={styles.divider} />
        <Box sx={styles.reflectBox}>{eventTeam.name}</Box>
      </Box>
      <Box sx={styles.buttonsBox}>
        <Button sx={styles.backButton} onClick={handleBack}>
          back
        </Button>
        <Button sx={styles.buttonNext} onClick={handleNext}>
          next
        </Button>
      </Box>
    </Box>
  );
};

export default EventCreateTeam;
